"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLessonsRescheduleOptions = exports.generateLessonsTimestamps = exports.getLessonStatusForUid = void 0;
const constants_1 = require("../utils/constants");
const types_1 = require("../types");
// tested only for Cancelled and Regular
const getLessonStatusForUid = (lesson, uid) => {
    // NOTE: In theory might be more than 1 student with same uid (parent)
    const student = lesson.students.find((s) => s.uid === uid);
    if (!student)
        return lesson.status;
    if (lesson.status === types_1.LessonStatus.Cancelled ||
        student.status === types_1.LessonStatus.Cancelled)
        return types_1.LessonStatus.Cancelled;
    return student.status;
};
exports.getLessonStatusForUid = getLessonStatusForUid;
const generateLessonsTimestamps = (options) => {
    const { start, end, daysOff, day, time } = options;
    const [hour, minute] = time.split(':').map((x) => parseInt(x));
    let ts = start.clone();
    ts = ts.day((0, constants_1.Weekday2Number)(day));
    ts = ts.minute(minute).hour(hour);
    ts = ts.startOf('minute');
    if (ts.isBefore(start))
        ts = ts.add(1, 'week');
    const acc = [];
    while (ts.isBefore(end)) {
        if (!daysOff.some((x) => x.isSame(ts, 'day')))
            acc.push(ts);
        ts = ts.add(1, 'week');
    }
    return acc;
};
exports.generateLessonsTimestamps = generateLessonsTimestamps;
const calculateLessonsRescheduleOptions = (slots, lesson, daysOff) => {
    const lessonType = (0, constants_1.getLessonTypeForCode)(lesson.code);
    const relevantSlots = slots === null || slots === void 0 ? void 0 : slots.filter((s) => {
        const slotLessonType = (0, constants_1.getLessonTypeForCode)(s.code);
        return (!s.hidden
            && slotLessonType === lessonType
            && s.duration === lesson.duration);
    });
    // dodanie lekcji o statusie odwołane, które są wolne
    // Implementation goes here
    return [];
};
exports.calculateLessonsRescheduleOptions = calculateLessonsRescheduleOptions;
